





































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { ClaimPaginator, ClaimsState } from '@/stores/claims/types';
import Paginator from '@/components/Paginator.vue';
import { PaginatorEvent, Claim } from '@/types';
import NewClaimModal from '@/components/modals/NewClaimModal.vue';

const namespace: string = 'claims';

@Component({
    components: {
        Paginator,
        NewClaimModal,
    },
})
export default class ClaimsView extends Vue {
    @State('claims') claims!: ClaimsState;
    @Action('get', { namespace }) getClaims: any;
    @Action('post', { namespace }) postClaimData: any;
    @Getter('claims', { namespace }) claimsPaginator!: ClaimPaginator;

    fields: any = [
        {
            label: 'Defender',
            key: 'defender.name',
            sortable: true,
        },
        {
            label: 'Offender',
            key: 'offender.name',
            sortable: true,
        },
        {
            key: 'status',
            label: 'Status',
            sortable: true,
        },
        {
            label: 'Assignee',
            key: 'assignee.name',
            sortable: true,
        },
        {
            key: 'actions',
            label: 'Actions',
        },
    ];

    filterData: any = {
        currentPage: 1,
        perPage: 10,
        search: '',
        archived: true,
        sortBy: '',
        sortDesc: true,
    };

    currentPage: any = 1;
    perPage: any = 10;
    search: string = '';
    archived: boolean = false;
    sortBy: string = '';
    sortDesc: boolean = true;

    editClaim: Claim = {
        defender: undefined,
        offender: undefined,
        assignee: undefined,
        status: '',
    };

    @Watch('filterData', { deep: true})
    onPropertyChanged() {
        this.updateRouteQuery();
        this.updateClaims();
    }


    updateRouteQuery() {
        this.$router.push({
            query: {
                page: this.filterData.currentPage,
                perPage: this.filterData.perPage,
                sortBy: this.filterData.sortBy,
                sortDesc: this.filterData.sortDesc.toString(),
                search: this.filterData.search,
                archived: this.filterData.archived.toString(),
            },
        });
    }

    created() {
        const tmpCurrenPage = this.$route.query.page || 1;
        const tmpPerPage = this.$route.query.perPage || 10;
        const tmpSearch = this.$route.query.search;
        const tmpSortDesc = Array.isArray(this.$route.query.sortDesc) ?
            this.$route.query.sortDesc[0] === 'true' :
            this.$route.query.sortDesc === 'true';
        const tmpSortBy = this.$route.query.sortBy || '';
        const tmpArchived = Array.isArray(this.$route.query.archived) ?
            this.$route.query.archived[0] === 'true' :
            this.$route.query.archived === 'true';

        this.filterData = {
            currentPage: tmpCurrenPage,
            perPage: tmpPerPage,
            search: tmpSearch,
            archived: tmpArchived,
            sortBy: tmpSortBy,
            sortDesc: tmpSortDesc,
        };
    }

    mounted() {
        this.updateClaims();
    }

    updateClaims() {
        this.getClaims({
            page: this.filterData.currentPage,
            perPage: this.filterData.perPage,
            search: this.filterData.search,
            archived: this.filterData.archived,
            sortBy: this.filterData.sortBy,
            sortDesc: this.filterData.sortDesc,
        });
    }


    updatePaginate(paginatorObject: PaginatorEvent) {
        this.filterData.perPage = paginatorObject.perPage;
        this.filterData.currentPage = paginatorObject.currentPage;
        this.updateClaims();
    }

    get claimsData() {
        return this.claimsPaginator && this.claimsPaginator.data;
    }

    get claimsPages() {
        return this.claimsPaginator && this.claimsPaginator.metadata;
    }

    onRowClicked(item: any, index: number, event: Event) {
        this.$router.push({ name: 'claim', params: { id: item.id } });
    }

    openNewClaimModal() {
        this.editClaim = {
            defender: undefined,
            offender: undefined,
            assignee: undefined,
            status: '',
        };
        this.$nextTick(() => {
            ((this.$refs.newClaimModalRef) as any).showModal();
        });
    }

    openEditClaimModal(id: number) {
        this.editClaim = this.claimsData[id];
        this.$nextTick(() => {
            ((this.$refs.newClaimModalRef) as any).showModal();
        });
    }


    saveNewClaim(claim: Claim) {
        this.postClaimData({
            claim,
            page: this.currentPage,
            perPage: this.perPage,
            search: this.search,
            archived: this.archived,
            sortBy: this.sortBy,
            sortDesc: this.sortDesc,
        });
    }

}
